var render = function render(){var _vm=this,_c=_vm._self._c;return _c('decorator-icon',_vm._b({},'decorator-icon',_vm.attrs,false),[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.276 8.66668L8.47133 12.862L7.52867 13.8047L1.724 8.00001L7.52867 2.19534L8.47133 3.13801L4.276 7.33334H14V8.66668H4.276Z","fill":"inherit"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }